var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { HubBlockQueryCommand } from '../../../commands/pagination.query.command';
import { BaseComponent } from '../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData } from '../../../common/components/confirm.modal/confirm.modal.provider';
import { AlertifyService } from '../../../services/alertify.service';
import { HubApiService } from '../../../services/hub.api.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { BlockKeywordCommand } from '../../../commands/accounts/block.keyword.command';
import { ImageService } from '../../../services/image.service';
import { HubComponent } from '../hub.component';
import { ModalService } from '../../../common/services/modal.service';
import { constantConfigs } from '../../../common/constants/constant';
import { EventTimeService } from '../../../services/event.time.service';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import * as jwt_decode from 'jwt-decode';
var BlockKeywordsComponent = /** @class */ (function (_super) {
    __extends(BlockKeywordsComponent, _super);
    function BlockKeywordsComponent(hubApiService, formBuilder, activatedRoute, parent, imageService, alertify, modalService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.hubApiService = hubApiService;
        _this.formBuilder = formBuilder;
        _this.activatedRoute = activatedRoute;
        _this.parent = parent;
        _this.imageService = imageService;
        _this.alertify = alertify;
        _this.modalService = modalService;
        _this.blacklist = [];
        _this.blockedEventDomains = [];
        _this.blockPlaces = [];
        _this.blockByGlobalKeywordsPlaces = [];
        _this.blockByClientKeywordsPlaces = [];
        _this.clientPlaceBlockKeywords = [];
        _this.blockEvents = [];
        _this.blockOrganizers = [];
        _this.blackType = 'keyword';
        _this.blackSourceItems = [
            {
                text: 'keyword',
                value: 'keyword',
                selected: true,
            },
            {
                text: 'organizer / venue',
                value: 'user',
            },
        ];
        return _this;
    }
    BlockKeywordsComponent.prototype.ngOnInit = function () {
        this.facebookHost = constantConfigs.facebook.host;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.blockKeywordsFormGroup = this.formBuilder.group({
            blackValue: [null, [Validators.required]],
        });
        this.blockPlacesCommand = new HubBlockQueryCommand();
        this.blockEventsCommand = new HubBlockQueryCommand();
        this.getBlacklist();
        this.getBlockPlaces();
        this.getBlockEvents();
        this.getBlockOrganizers();
        this.getBlockedEventDomains();
        this.getGlobalBlockedByKeywordsPlaceList();
        this.getClientPlaceBlockKeywords();
        this.getClientPlaceBlockKeywordsPlaceList();
    };
    BlockKeywordsComponent.prototype.typeSourceChange = function (target) {
        this.blackType = target.value;
    };
    BlockKeywordsComponent.prototype.blockPlaceKeywords = function (event) {
        var _this = this;
        this.hubApiService
            .addClientPlaceBlockKeyword(this.hubName, this.clientPlaceBlockKeywords)
            .finally(event.complete)
            .subscribe(function (data) {
            _this.alertify.successfully('Set blocked keywords for places');
        });
    };
    BlockKeywordsComponent.prototype.revertBlockOrganizer = function (organizer) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.hubApiService
                    .unBlockOrganizer(_this.hubName, organizer)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.getBlockOrganizers();
                    _this.getBlockEvents();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to revert this organizer?',
            confirmModalConfirmButtonText: 'Revert',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    BlockKeywordsComponent.prototype.revertBlockEvent = function (eventItem) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.hubApiService
                    .unBlock(_this.hubName, eventItem._id)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.getBlockPlaces();
                    _this.getBlockEvents();
                    _this.getBlockOrganizers();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            // confirmModalDescription: 'Are you sure you want to revert this item, and all events of this organizer will be reverted too?',
            confirmModalDescription: 'Are you sure you want to revert this event?',
            confirmModalConfirmButtonText: 'Revert',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    BlockKeywordsComponent.prototype.revertBlockPlace = function (placeItem) {
        var _this = this;
        var actions = {
            confirm: function (place) {
                _this.hubApiService
                    .unBlockPlace(_this.hubName, placeItem._id)
                    .finally(place.complete)
                    .subscribe(function () {
                    _this.getBlockPlaces();
                    _this.getBlockEvents();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to revert this item?',
            confirmModalConfirmButtonText: 'Revert',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    BlockKeywordsComponent.prototype.deleteBlockKeyword = function (blackItem) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.command = new BlockKeywordCommand(blackItem.blackValue, blackItem.blackType);
                _this.hubApiService
                    .deleteBlockKeyword(_this.hubName, _this.command)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.getBlacklist();
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to remove this item?',
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    BlockKeywordsComponent.prototype.addBlockKeyword = function (event) {
        var _this = this;
        this.command = new BlockKeywordCommand(this.keywordText, this.blackType);
        this.hubApiService
            .addBlockKeyword(this.hubName, this.command)
            .finally(event.complete)
            .subscribe(function () {
            _this.alertify.successfully('Add keyword');
            _this.keywordText = null;
            _this.getBlacklist();
        });
    };
    BlockKeywordsComponent.prototype.getBlacklist = function () {
        var _this = this;
        this.hubApiService.getBlockKeywords(this.hubName).subscribe(function (data) {
            if (data && data.length > 0) {
                data = data.sort(function (a, b) {
                    if (a.blackType < b.blackType)
                        return -1;
                    if (a.blackType > b.blackType)
                        return 1;
                    if (a.blackValue < b.blackValue)
                        return -1;
                    if (a.blackValue > b.blackValue)
                        return 1;
                    return 0;
                });
            }
            _this.blacklist = data;
        });
    };
    BlockKeywordsComponent.prototype.getGlobalBlockedByKeywordsPlaceList = function () {
        var _this = this;
        this.hubApiService.getGlobalBlockedByKeywordsPlaces(this.hubName).subscribe(function (data) {
            if (data && data.length > 0) {
                data = data.sort(function (a, b) {
                    var aTitle = a.title || a.name;
                    var bTitle = b.title || b.name;
                    if (aTitle < bTitle)
                        return -1;
                    if (aTitle > bTitle)
                        return 1;
                    return 0;
                });
            }
            _this.blockByGlobalKeywordsPlaces = data;
        });
    };
    BlockKeywordsComponent.prototype.getClientPlaceBlockKeywordsPlaceList = function () {
        var _this = this;
        this.hubApiService.getClientPlaceBlockKeywordsPlaceList(this.hubName).subscribe(function (data) {
            if (data && data.length > 0) {
                data = data.sort(function (a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
            }
            _this.blockByClientKeywordsPlaces = data;
        });
    };
    BlockKeywordsComponent.prototype.getClientPlaceBlockKeywords = function () {
        var _this = this;
        this.hubApiService.getClientPlaceBlockKeywords(this.hubName).subscribe(function (data) {
            if (data && data.length > 0) {
                data = data.sort(function (a, b) {
                    if (a < b)
                        return -1;
                    if (a > b)
                        return 1;
                    return 0;
                });
            }
            _this.clientPlaceBlockKeywords = data;
        });
    };
    BlockKeywordsComponent.prototype.getBlockedEventDomains = function () {
        var _this = this;
        this.hubApiService.getBlockedEventDomains(this.hubName).subscribe(function (data) {
            if (data && data.length > 0) {
                data = data.sort(function (a, b) {
                    if (a < b)
                        return -1;
                    if (a > b)
                        return 1;
                    return 0;
                });
            }
            _this.blockedEventDomains = data;
        });
    };
    BlockKeywordsComponent.prototype.updateBlockedEventDomains = function (event) {
        var _this = this;
        this.hubApiService
            .updateBlockedEventDomains(this.hubName, this.blockedEventDomains)
            .takeUntil(this.isDestroyed)
            .finally(event.complete)
            .subscribe(function () {
            _this.alertify.successfully('Set blocked event domain');
        });
    };
    BlockKeywordsComponent.prototype.getBlockOrganizers = function () {
        var _this = this;
        this.hubApiService.getBlockedOrganizers(this.hubName).subscribe(function (data) {
            _this.blockOrganizers = data;
        });
    };
    BlockKeywordsComponent.prototype.getBlockEvents = function () {
        var _this = this;
        this.hubApiService.getBlockEvents(this.hubName, this.blockEventsCommand).subscribe(function (data) {
            data.forEach(function (item) {
                item = EventTimeService.processEventTime(item);
            });
            if (data && data.length > 0) {
                data = data.sort(function (a, b) {
                    if (a.startTime < b.startTime)
                        return -1;
                    if (a.startTime > b.startTime)
                        return 1;
                    return 0;
                });
            }
            _this.blockEvents = data;
        });
    };
    BlockKeywordsComponent.prototype.getBlockPlaces = function () {
        var _this = this;
        this.hubApiService.getBlockPlaces(this.hubName, this.blockPlacesCommand.queryParams).subscribe(function (data) {
            _this.blockPlaces = data;
            if (_this.blockPlaces && _this.blockPlaces.length > 0) {
                _this.blockPlaces = _this.blockPlaces.sort(function (a, b) {
                    var aTitle = a.title || a.name;
                    var bTitle = b.title || b.name;
                    if (aTitle < bTitle)
                        return -1;
                    if (aTitle > bTitle)
                        return 1;
                    return 0;
                });
            }
        });
    };
    BlockKeywordsComponent.prototype.deleteEventPermanently = function (eventItem) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.hubApiService
                    .deleteEvent(_this.hubName, eventItem._id)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.getBlockPlaces();
                    _this.getBlockEvents();
                    _this.getBlockOrganizers();
                });
            },
            cancel: function () { },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: "Are you sure you want to remove this event permanently, this operation cannot be reverted. " + (eventItem.isManuallyCreated ? '' : 'But this event will be added again in the next deliveries.'),
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    BlockKeywordsComponent.prototype.deletePlacePermanently = function (placeItem) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.hubApiService
                    .deletePlace(_this.hubName, placeItem._id)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.getBlockPlaces();
                    _this.getBlockEvents();
                });
            },
            cancel: function () { },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: "Are you sure you want to remove this place permanently, this operation cannot be reverted. " + (placeItem.isManuallyCreated ? '' : 'But this place will be added again in the next deliveries.'),
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    BlockKeywordsComponent.prototype.tabChanged = function ($event) {
        if (!window.location.href.includes('localhost')) {
            var authToken = localStorage.getItem(localStorageKeys.authToken);
            var tokenInfo = jwt_decode(authToken);
            try {
                var trackName = "click - ContentManagement - BlockKeywords - " + $event.tab.textLabel;
                window['pendo'].track(trackName, {
                    accountId: tokenInfo.userName,
                    timestamp: Date.now(),
                    hubName: this.hubName
                });
            }
            catch (error) {
                console.error(error);
            }
        }
    };
    return BlockKeywordsComponent;
}(BaseComponent));
export { BlockKeywordsComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/block.keywords/block.keywords.component.ts.pre-build-optimizer.js